var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.list.length)?_c('div',_vm._l((_vm.list),function(item){return _c('div',{key:item,staticClass:"title",on:{"click":()=>_vm.open(item)}},[_vm._v(_vm._s(_vm._f("sliceUrl")(item)))])}),0):_c('span',[_vm._v("--")])])
}
var staticRenderFns = []

export { render, staticRenderFns }